

  import {Component, Vue} from "vue-property-decorator";
  import AuditTabPane from "../components/AuditTabPane.vue";
  import {AuditUserLogType} from "@/api/appService";
  import api from '@/api/index'

  @Component({name:'AuditTabOfProject',
    components: {AuditTabPane}
  })
  export default class AuditTabOfProject extends Vue{

    getHostType(){
      return AuditUserLogType.Project;
    }

    fetchData(){
      return api.project.getMyAll;
    }

    audit(){
      return api.project.audit;
    }

    handleCountChange(value:number){
      this.$emit('count-changed',value);
    }

  }

